<!-- vue2 二次封装el-form-item -->
<template>
  <el-form-item class="ZFFormItem" :class="{ 'not-empty': fieldValue }" :prop="prop">
    <template #default>
      <slot name="default"></slot>
    </template>
    <template #label>
      <label class="zf-form-item-label">{{ label }}</label>
    </template>
  </el-form-item>
</template>
<script>
import { getPropByPath } from 'element-ui/src/utils/util'
export default {
  name: 'ZFFormItem',
  data() {
    return {
      isNested: false
    }
  },
  props: {
    prop: {
      type: String
    },
    label: {
      type: String
    },
    status: {
      type: Boolean,
      default: false
    },
    iconStatus: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String
    }
  },
  computed: {
    form() {
      let parent = this.$parent
      let parentName = parent.$options.componentName
      while (parentName !== 'ElForm') {
        if (parentName === 'ElFormItem') {
          this.isNested = true
        }
        parent = parent.$parent
        parentName = parent.$options.componentName
      }
      return parent
    },
    fieldValue() {
      const model = this.form.model
      if (!model || !this.prop) {
        return
      }
      let path = this.prop
      if (path.indexOf(':') !== -1) {
        path = path.replace(/:/, '.')
      }
      return getPropByPath(model, path, true).v
    }
  },
  methods: {}
}
</script>
<style lang="scss">
$form-item-height: 45px;
$form-color-danger: #f22d3c;
$input-placeholder-color: #5f6979;
.ZFFormItem.el-form-item {
  position: relative;
  margin-bottom: 30px;
  &.is-error {
    .el-input__inner {
      border-color: $form-color-danger;
    }
    .zf-form-item-label {
      color: $form-color-danger;
    }
  }
  &.not-empty,
  &.is-error,
  &.is-success {
    .zf-form-item-label {
      display: block;
    }
  }

  .zf-form-item-label {
    display: none;
    position: absolute;
    z-index: 1;
    top: -7px;
    left: 10px;
    padding: 0 10px;
    line-height: 14px;
    background-color: #fff;
    color: $input-placeholder-color;
    transform: scale(0.85);
  }

  .el-form-item__content {
    line-height: $form-item-height;
  }

  .el-form-item__error {
    left: auto;
    right: 0;
    color: $form-color-danger;
  }

  .el-input__inner {
    height: $form-item-height;
    line-height: $form-item-height;
  }
}
</style>
